import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, { parseFractionLikeInput, formatFractionLatexCore } from "../../../../components/inputs/FractionInput";
import { pick, range } from "../commonSolidPi";

export function generateTask() {
  const r = pick(range(2, 8));
  const h = pick([3, 6, 9, 12]);
  const k = (r * r * h) / 3;
  return { type: "ConeHeightFromVolumeTask", data: { r, h, k } };
}

export function renderTask({ data }) {
  return (
    <div style={{ marginBottom: 12 }}>
      Stożek ma promień podstawy <InlineMath math={`${data.r}`} />, a jego objętość jest równa{" "}
      <InlineMath math={`${data.k}\\pi`} />. Oblicz wysokość stożka.
    </div>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="h"
      placeholder="np. 6"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  const parsed = Number.isFinite(userAnswer?.parsed)
    ? userAnswer.parsed
    : parseFractionLikeInput(userAnswer?.raw || "");
  return Number.isFinite(parsed) && Math.abs(parsed - data.h) <= 1e-6;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`h=${data.h}`} />;
}

export function renderUserAnswer(userAnswer) {
  const raw = userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`h=${formatFractionLatexCore(raw) || raw}`} />;
}

export function renderExplanation({ data }) {
  const { r, h, k } = data;
  return (
    <div style={{ display: "grid", rowGap: 8 }}>
      <p><strong>Krok 1.</strong> Zaczynamy od wzoru na objętość stożka.</p>
      <BlockMath math={`V=\\frac{1}{3}\\pi r^2h`} />
      <p><strong>Krok 2.</strong> Podstawiamy dane i skracamy przez <InlineMath math={`\\pi`} />.</p>
      <BlockMath math={`${k}\\pi=\\frac{1}{3}\\pi\\cdot ${r}^2\\cdot h`} />
      <BlockMath math={`${k}=\\frac{${r * r}}{3}h`} />
      <p><strong>Krok 3.</strong> Wyznaczamy wysokość.</p>
      <BlockMath math={`h=${h}`} />
      <p><strong>Odpowiedź:</strong> <InlineMath math={`h=${h}`} />.</p>
    </div>
  );
}
